export default "__VITE_ASSET__BbXA43NS__"